import { render, staticRenderFns } from "./pure.vue?vue&type=template&id=373cb854&scoped=true&"
import script from "./pure.vue?vue&type=script&lang=js&"
export * from "./pure.vue?vue&type=script&lang=js&"
import style0 from "./pure.vue?vue&type=style&index=0&id=373cb854&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373cb854",
  null
  
)

export default component.exports